import { DetailsSectionWrapper, ViewPageListTab } from 'app/main/components/page-layouts';
import type { ViewPageContentTabType } from 'app/main/components/page-layouts/view/ViewPage';

import PhonesErrorsView from '../tabs/PhonesErrorsView';
import PhonesModuleListItem from '../PhonesModuleListItem';

const tabs: ViewPageContentTabType[] = [
	{
		id: 'list',
		title: 'TAB_LIST',
		content: props => <ViewPageListTab {...props} itemLayout={PhonesModuleListItem} />
	},
	{
		id: 'duplicates',
		title: 'TAB_ERRORS',
		content: () => (
			<DetailsSectionWrapper disablePadding>
				<PhonesErrorsView />
			</DetailsSectionWrapper>
		)
	}
];

export default tabs;
